import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VTextField,
    _vm._g(
      _vm._b(
        {
          staticClass: "text-input text-body-1",
          class: { "text-input_disabled": _vm.disabled },
          attrs: {
            "background-color": "bg-gray-40",
            height: "48px",
            dense: "",
            solo: "",
            flat: "",
            outlined: "",
            "hide-details": "",
          },
          scopedSlots: _vm._u([
            {
              key: "prepend-inner",
              fn: function () {
                return [
                  _c(
                    "svg",
                    {
                      staticClass: "search-icon b-icon b-icon-search",
                      class: { "search-icon_disabled": _vm.disabled },
                      attrs: { width: "20", height: "20" },
                    },
                    [
                      _c("use", {
                        attrs: {
                          "xlink:href":
                            "/static/_v1/pd/svg-sprites/global.svg#icon-search",
                        },
                      }),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        "v-text-field",
        { ..._vm.$attrs, ..._vm.$props },
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }